<div *transloco="let t; read:'permit'" class="root">
    <div *ngIf="(currentStep$ | async).step === PermitStep.isFlammableHotWork" class="root__question-text" [innerHTML]="t('isFlammableHotWork')"></div>
    <div *ngIf="(currentStep$ | async).step === PermitStep.isWorkplaceTemporary" class="root__question-text" [innerHTML]="t('isWorkplaceTemporary')"></div>

    <div *ngIf="(currentStep$ | async).step === PermitStep.isFlammableHotWork"  class="root__comment" [innerHTML]="t('isFlammableHotWorkComment')"></div>
    <div *ngIf="(currentStep$ | async).step === PermitStep.isWorkplaceTemporary" class="root__comment" [innerHTML]="t('isWorkplaceTemporaryComment')"></div>

    <div *ngIf="(currentStep$ | async).step === PermitStep.isFlammableHotWork" class="root__choices">
        <div class="root__choices__item" [class.root__choices__item--active]="isFlammableWork === true" (click)="selectFlammableWork(true)">
            {{ t("yes") }}
        </div>
        <div class="root__choices__item" [class.root__choices__item--active]="isFlammableWork === false" (click)="selectFlammableWork(false)">
            {{ t("no") }}
        </div>
    </div>

    <div *ngIf="(currentStep$ | async).step === PermitStep.isWorkplaceTemporary" class="root__choices">
        <div class="root__choices__item" [class.root__choices__item--active]="isWorkplaceTemporary === true" (click)="selectWorkplaceTemporary(true)">
            {{ t("yes") }}
        </div>
        <div class="root__choices__item" [class.root__choices__item--active]="isWorkplaceTemporary === false" (click)="selectWorkplaceTemporary(false)">
            {{ t("no") }}
        </div>
    </div>

    <div class="root__actions">
        <button class="root__actions__back" type="button" (click)="goBack()">{{ t("back") }}</button>
        <button class="root__actions__continue" type="button" (click)="continue()" [class.root__actions__continue--disabled]="!canProceed">
            {{ t("next") }}
        </button>
    </div>
</div>
